import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Manual extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="manual" className="a-breadcrumbs">คู่มือสมาชิก</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-sm-9 mb-sm-50">
              {/* section title*/}
              <h2 className="title-section mt-0 mb-0"><span>คู่มือสมาชิก</span></h2><br/>
              {/* ! section title*/}
              <div className="divider gray left mt-20 mb-25" />
              <a href="Form/คู่มือสมาชิก.pdf" target="_blank" style={{color: '#0094ff',fontSize:20}}>คู่มือสมาชิก.pdf</a>
              <a href="Form/คู่มือสมาชิก.pdf" target="_blank"><img src="Img/Board/cover-mannual.png" /></a>
            </div>
          </div>
        </div>
        </section>
      </div>
    );
  }
}

export default Manual;
